import _ from "underscore";

const dateRangePanelTemplate = options => {
  let namePrefix;
  const collapse = {};
  let subClass;
  options = options || {};
  namePrefix = options.namePrefix || 'default';
  if (_.isObject(options.collapse)) {
    collapse.show = options.collapse.show || false;
  }
  subClass = options.subClass || false;

  let collapseHeader;
  let collapseBody;
  let collapseCaret;
  let subClassName;

  if (_.isObject(options.collapse)) {
    collapseHeader = `data-toggle="collapse" href="[data-name='${namePrefix}-range-body']"`;

    if (collapse.show) {
      collapseBody = 'collapse show';
      collapseCaret = '<div class="caret caret-open">&nbsp;</div>';
    } else {
      collapseBody = 'collapse';
      collapseCaret = '<div class="caret">&nbsp;</div>';
    }
  } else {
    collapseHeader = '';
    collapseBody = '';
    collapseCaret = '';
  }

  if (subClass) {
    subClassName = ` ${namePrefix}-date-range-panel`;
  } else {
    subClassName = '';
  }

  const content = `
          <div class="date-range-panel${subClassName}">
            <a ${collapseHeader}>
              <div class="date-range-panel-header">
                <span class="date-range-panel-title" data-name="${namePrefix}-header"></span>
                ${collapseCaret}
              </div>
            </a>
            <div class="date-range-panel-body ${collapseBody}" data-name="${namePrefix}-range-body">
              <div class="date-range" data-name="${namePrefix}-range">
                <div data-name="${namePrefix}-range-start"></div>
                <div data-name="${namePrefix}-range-end"></div>
              </div>
            </div>
          </div>`;

  return content;
};

export default function dateRangeTemplate(options) {
  let compareMode;
  let compareSwitch;
  let panelsContainerContent;
  let reportTimezone;
  let switchSectionContent;
  let content;

  compareMode = options.compareMode || false;
  reportTimezone = options.reportTimezone || "";
  compareSwitch = options.compareSwitch || false;

  if (compareSwitch) {
    switchSectionContent = `
          <span class="date-range-time-zone" data-name="date-range-time-zone">${reportTimezone}</span>
          <span class="mr-small">Compare Mode</span>
          <input type="checkbox" name="compare-mode-switch" data-on-color="success">`;
  } else {
    switchSectionContent = `
          <span class="date-range-time-zone" data-name="date-range-time-zone">${reportTimezone}</span>`;
  }

  if (compareMode) {
    panelsContainerContent =
      dateRangePanelTemplate({ namePrefix: "primary", collapse: { show: true }, subClass: true }) +
      dateRangePanelTemplate({ namePrefix: "secondary", collapse: { show: true }, subClass: true });
  } else {
    panelsContainerContent = dateRangePanelTemplate({ namePrefix: "primary" });
  }

  content = `
        <div class="list-group date-range-list-container" data-name="date-range-list-container"></div>
        <div class="date-range-compare-mode-switch-container" data-name="date-range-compare-switch">
        ${switchSectionContent}
        </div>
        <div class="date-range-panels-container" data-name="date-range-panels-container">
          ${panelsContainerContent}
        </div>`;

  return content;
}
